import config from "../config";
import moment from "moment";

export default function VideoCardSmall(p) {
  let cardStyle = { width: 200, height: 170 };
  let imageBlockStyle = { height: 111 };
  let imageStyle = { margin: "auto", display: "block", width: "100%", objectFit: "cover", height: 111 };
  let titleSize = "mx-1 text-sm ";

  return (
    <a
      href={p.projectUrl}
      key={p.projectid}
      className="bg-white shadow-md rounded-lg overflow-hidden flex flex-col justify-between bg-white  mb-2"
    >
      <div key={p.projectid} style={cardStyle}>
        <div className="flex flex-col justify-end border" style={imageBlockStyle}>
          <div>
            <img key={p.projectid} src={p.previewImageUrl} style={imageStyle} height="111px" width="200px" />
          </div>
        </div>
        <div className={"font-bold tracking-tighter my-1 " + titleSize}>
          <div
            style={{
              wordBreak: "keep-all",
              overflow: "hidden",
              textOverflow: "ellipsis",
              /*fontWeight: "bolder", */
              whiteSpace: "nowrap",
              color: "#bfbbbb",
            }}
          >
            {p.name}
          </div>
        </div>
        <div className={" " + titleSize}>
          <div
            style={{
              wordBreak: "keep-all",
              overflow: "hidden",
              textOverflow: "ellipsis",
              color: "grey",
              fontSize: "smaller",
            }}
          >
            {moment(p.created).fromNow()}
          </div>
        </div>
      </div>
    </a>
  );
}
